import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

import LogoutIcon from "@mui/icons-material/Logout";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MenuRoutes from "../../Components/AppContainer/config";

const drawerWidth = 250;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: open ? 0 : -drawerWidth, // AA used to move the Main to the right to fit space for the drawer
        overflowX: "hidden", // Ensures no horizontal scrollbar appears when shrinking
    })
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth, //AA used to move the Appbar to the right to fit space for the drawer
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
}));

const AppContainer = ({ children }) => {
    const signOut = useSignOut();
    const navigate = useNavigate();
    const userData = useAuthUser();
    console.log(userData);
    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const AppDrawer = () => {
        return (
            <Drawer
                dir={theme.direction === "rtl" ? "rtl" : "ltr"}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: drawerWidth,
                    },
                }}
                variant="persistent"
                // {theme.direction === "rtl" ? "right" : "left"}
                anchor={theme.direction === "rtl" ? "left" : "left"} //AA
                open={open}
            >
                <DrawerHeader
                    dir={theme.direction === "rtl" ? "rtl" : "ltr" /* //AA*/}
                >
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === "rtl" ? (
                            <ChevronRightIcon />
                        ) : (
                            <ChevronLeftIcon />
                        )}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <List>
                    {MenuRoutes.filter(({ allowedUsers }) =>
                        allowedUsers.includes(userData?.employeeType?.id)
                    ).map((MenuRoute) => (
                        <ListItem
                            key={MenuRoute.text}
                            disablePadding
                            onClick={() => navigate(MenuRoute.route)}
                        >
                            <ListItemButton>
                                <ListItemIcon>{MenuRoute.icon}</ListItemIcon>
                                <ListItemText primary={MenuRoute.text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
                <Divider />
                <ListItem sx={{ mt: "auto" }}>
                    <ListItemButton
                        onClick={() => {
                            signOut();
                            window.location.reload();
                        }}
                        sx={{
                            background: "#f44336",
                            borderRadius: "5px",
                            color: "white",
                            "&:hover": {
                                background: "#f55",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <LogoutIcon
                                sx={{ color: "white", fill: "white" }}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Log Out" />
                    </ListItemButton>
                </ListItem>
            </Drawer>
        );
    };

    return (
        <Box
            sx={{
                display: "flex",
                minHeight: "100vh",
            }}
            dir={theme.direction === "rtl" ? "rtl" : "ltr"}
        >
            <CssBaseline />
            <AppDrawer />
            <AppBar
                position="fixed"
                open={open}
                dir={theme.direction === "rtl" ? "rtl" : "ltr"}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="end"
                        onClick={handleDrawerOpen}
                        sx={{ ...(open && { display: "none" }) }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        noWrap
                        sx={{ flexGrow: 1 }}
                        component="div"
                        marginLeft="20px"
                    >
                        Pharmacy App
                    </Typography>
                </Toolbar>
            </AppBar>
            <Main open={open}>
                <DrawerHeader />
                {children}
            </Main>
            <ToastContainer />
        </Box>
    );
};
export default AppContainer;
